function updateTimer() {
  // selectedDate format = "May 20, 2024 15:14:00"
  const selectedDate = $('[data-countdown-timer-date]').attr('data-countdown-timer-date');
  
  future  = Date.parse(selectedDate);
  now     = new Date();
  diff    = future - now;

  days  = Math.floor( diff / (1000*60*60*24) );
  hours = Math.floor( diff / (1000*60*60) );
  mins  = Math.floor( diff / (1000*60) );
  secs  = Math.floor( diff / 1000 );

  d = days;
  h = hours - days  * 24;
  m = mins  - hours * 60;
  s = secs  - mins  * 60;

  // Time has expired
  if (d < 0) {
    d = 0;
    h = 0;
    m = 0;
    s = 0;
  }

  const countdownTimers = document.querySelectorAll('[data-countdown-timer]');

  countdownTimers.forEach(element => {
      element
        .innerHTML =
          '<div class="countdown-timer__unit">' + d + '<span class="countdown-timer__unit-label">Days</span></div>' +
          '<div class="countdown-timer__unit">' + h + '<span class="countdown-timer__unit-label">Hrs</span></div>' +
          '<div class="countdown-timer__unit">' + m + '<span class="countdown-timer__unit-label">Mins</span></div>' +
          '<div class="countdown-timer__unit">' + s + '<span class="countdown-timer__unit-label">Secs</span></div>' ;
  });
}

const fadeIn = () => {
  // Nice fade-in onload
  const hiddenElements = document.querySelectorAll('.countdown-timer--hidden');
  hiddenElements.forEach(element => {
    $(element).removeClass('countdown-timer--hidden');
  });
}


updateTimer();
fadeIn();

setInterval('updateTimer()', 1000 );

//  Detect section reload in theme editor
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    updateTimer();
    fadeIn();
  });
} 
